// [projects.project-files](../../../docs/product/projects.md#projects-project-files): posting, owner attachments and bids share the same file
// chooser/validation contract so their hints cannot promise unsupported formats.
export const PROJECT_DOCUMENT_ACCEPT = ".pdf,.png,.jpg,.jpeg,.webp,application/pdf,image/png,image/jpeg,image/webp";
const PROJECT_DOCUMENT_TYPES = new Set(["application/pdf", "image/png", "image/jpeg", "image/webp"]);
const MAX_PROJECT_DOCUMENT_BYTES = 25 * 1024 * 1024;

export function projectDocumentError(file: Pick<File, "type" | "size">): string | null {
  if (!PROJECT_DOCUMENT_TYPES.has(file.type)) return "Use a PDF, JPG, PNG, or WebP image.";
  if (file.size === 0 || file.size > MAX_PROJECT_DOCUMENT_BYTES) return "Each document must be non-empty and 25 MB or smaller.";
  return null;
}
